// src/components/layout/Header.js
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import {
    BellIcon,
    UserCircleIcon,
    Bars3Icon
} from '@heroicons/react/24/outline';
import { Menu, Transition } from '@headlessui/react';

const Header = ({ toggleSidebar }) => {
    const { user, logout } = useAuth();
    const [notifications, setNotifications] = useState([]);

    return (
        <header className="bg-white shadow h-16 fixed top-0 right-0 left-0 md:left-64 z-10">
            <div className="px-4 h-full flex items-center justify-between">
                <div className="flex items-center">
                    {/* Mobile menu button */}
                    <button
                        className="md:hidden mr-4 text-secondary-600 hover:text-secondary-900 focus:outline-none"
                        onClick={toggleSidebar}
                    >
                        <Bars3Icon className="h-6 w-6" />
                    </button>

                    {/* Visible on mobile only */}
                    <div className="md:hidden text-xl font-semibold text-secondary-800">
                        Fit2Ride
                    </div>

                    {/* Hidden on mobile */}
                    <div className="hidden md:block text-xl font-semibold text-secondary-800">
                        {/* Page title could go here */}
                    </div>
                </div>

                <div className="flex items-center">
                    {/* Notification dropdown */}
                    <Menu as="div" className="relative mr-2 md:mr-4">
                        <Menu.Button className="flex items-center justify-center h-8 w-8 rounded-full text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100 focus:outline-none">
                            <BellIcon className="h-5 w-5" />
                            {notifications.length > 0 && (
                                <span className="absolute top-0 right-0 h-4 w-4 rounded-full bg-red-600 text-white text-xs flex items-center justify-center">
                                    {notifications.length > 9 ? '9+' : notifications.length}
                                </span>
                            )}
                        </Menu.Button>

                        <Transition
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 mt-2 w-80 max-w-[90vw] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="px-4 py-3">
                                    <p className="text-sm">Notifications</p>
                                    {notifications.length === 0 ? (
                                        <p className="text-sm text-gray-500 py-2">No notifications</p>
                                    ) : (
                                         notifications.map((notification, index) => (
                                             <div key={index} className="py-2 border-b border-gray-100 last:border-b-0">
                                                 <p className="text-sm font-medium">{notification.title}</p>
                                                 <p className="text-xs text-gray-500">{notification.message}</p>
                                             </div>
                                         ))
                                     )}
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>

                    {/* User dropdown */}
                    <Menu as="div" className="relative">
                        <Menu.Button className="flex items-center text-sm rounded-full focus:outline-none">
                            <UserCircleIcon className="h-8 w-8 text-secondary-600" />
                            <span className="ml-2 text-secondary-800 hidden md:inline">{user?.name}</span>
                        </Menu.Button>

                        <Transition
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 mt-2 w-48 max-w-[90vw] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="px-1 py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                className={`${
                                                    active ? 'bg-primary-500 text-white' : 'text-gray-900'
                                                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                onClick={() => window.location.href = '/profile'}
                                            >
                                                Profile
                                            </button>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                className={`${
                                                    active ? 'bg-primary-500 text-white' : 'text-gray-900'
                                                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                onClick={() => window.location.href = '/settings'}
                                            >
                                                Settings
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="px-1 py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                className={`${
                                                    active ? 'bg-red-500 text-white' : 'text-gray-900'
                                                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                                onClick={logout}
                                            >
                                                Logout
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
            </div>
        </header>
    );
};

export default Header;
